import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {BaseUserService} from '../auth/account/base-user.service';
import {TranslateService} from '../shared/translate.service';

@Injectable({
  providedIn: 'root'
})
export class InsititutionsService extends BaseUserService {
  private readonly baseUrl = 'portalApiUrl/omnis/libraries/all';
  private readonly baseUrlCities = 'portalApiUrl/omnis/libraries/cities/0/10000';

  constructor(protected http: HttpClient, public translateService: TranslateService) {
    super()
  }

  public getLibs(page: number , pageSize: number ) {
    return this.http.get<any>(this.baseUrl + `/${page}/${pageSize}/asc`);
  }

  public searchLibs(page: number, pageSize: number, sort: string , name?: string , city?: string , province?: string , digital?: string) {

    let params = new HttpParams();
    if (name && name !== '') {
      params = params.set('search_name', name);
    }
    if (city && city !== '') {
      params = params.set('search_city', city);
    }
    if (province && province !== this.translateService.translate('Institutions.placeholder.all')) {
      params = params.set('province', province);
    }
    if (digital && digital !== '') {
      if (digital === 'digital') {
        params = params.set('digital', 'true');
      } else if (digital === 'physical') {
        params = params.set('digital', 'false');
      }
    }
    return this.http.get<any>(this.baseUrl + `/${page}/${pageSize}/${sort}`, {
      params: params
    });
  }

  public getCities(value) {
    return this.http.get<any>(this.baseUrlCities, {params: {prefix: value}});
  }
}
